import React from 'react';

//style={{width: '50px', height:'50px'}}
const AppLoading = props => {
    const { size, styles = {} } = props;
    return (<div className="loader" style={{height:`${size}rem`, width:`${size}rem`, ...styles}} />)
};

export default AppLoading;